<template>
    <div>
        <hxlHeader />
        <div class="personalCenter" :class="{ 'menu-open': menuOpen }" @click.self="closeMenu">
            <!-- 移动端：侧边菜单收进这个按钮，点击后以抽屉形式浮出 -->
            <div class="pc-menu-bar">
                <span class="pc-menu-btn" @click="toggleMenu">
                    <i class="el-icon-menu"></i>
                    个人中心菜单
                </span>
            </div>
            <span v-if="menuOpen" class="pc-menu-close" @click="closeMenu">
                <i class="el-icon-close"></i>
            </span>
            <hxlMenu class="menu" />
            <hxlContent class="right" />
        </div>
        <hxlFooder />
    </div>
</template>

<script>
import hxlHeader from "@/views/common/header.vue";
import hxlFooder from "@/views/common/fooder.vue";
import hxlMenu from './menu.vue';
import hxlContent from './content.vue';

export default {
    components: {
        hxlMenu, hxlContent,
        hxlHeader, hxlFooder,
    },
    data() {
        return {
            // 移动端侧边菜单抽屉是否展开
            menuOpen: false,
        };
    },
    watch: {
        // 切换菜单项后路由变化，自动收起抽屉
        '$route'() {
            this.menuOpen = false;
        },
    },
    methods: {
        // 展开/收起侧边菜单抽屉
        toggleMenu() {
            this.menuOpen = !this.menuOpen;
        },
        // 收起侧边菜单抽屉
        closeMenu() {
            this.menuOpen = false;
        },
    },
};
</script>

<style lang="scss">
.personalCenter {
    width: 1200px;
    margin: auto;
    display: flex;
    align-items: flex-start;

    // height: 70vh;
    >div {
        &.menu {
            // max-height: 1000px;
            overflow-x: hidden;

            // width: 200px;
            // overflow-y: scroll;
            // height: 84vh;
            &::-webkit-scrollbar {
                width: 0;
            }
        }

        &.right {
            flex: 1;
            width: 900px;
            border: 1px solid #d3c290;
            margin-left: 20px;
            padding: 20px;
            // overflow-y: scroll;
            overflow-x: hidden;

            >div {
                // position: sticky;
                // top: 20px;
            }
        }
    }
}

// 移动端菜单触发按钮 / 抽屉关闭按钮：默认（PC 端）隐藏，仅 ≤1200px 时显示
.pc-menu-bar,
.pc-menu-close {
    display: none;
}

/* ===== 移动端适配（屏幕小于 1200px 即生效） ===== */
@media (max-width: 1200px) {
    .personalCenter {
        // 固定 1200px 会导致内容整体被裁掉，移动端改为自适应
        width: 100%;
        padding: 0 12px;
        box-sizing: border-box;
        flex-direction: column;

        // 菜单触发按钮（仅移动端可见）
        .pc-menu-bar {
            display: block;
            margin: 10px 0;
        }

        .pc-menu-btn {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            padding: 9px 16px;
            background-color: #2899df;
            color: #ffffff;
            font-size: 14px;
            border-radius: 4px;
            cursor: pointer;
            user-select: none;
        }

        // 抽屉关闭按钮
        .pc-menu-close {
            display: block;
            position: fixed;
            top: 12px;
            left: 12px;
            z-index: 2001;
            width: 30px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            border-radius: 50%;
            background-color: rgba(255, 255, 255, 0.92);
            color: #333333;
            font-size: 16px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
            cursor: pointer;
        }

        // 侧边菜单：默认收起
        >div.menu {
            display: none;
        }

        &.menu-open {

            // 抽屉式浮层：从左侧滑出，内部可纵向滚动
            >div.menu {
                display: block;
                position: fixed;
                left: 0;
                top: 0;
                bottom: 0;
                width: 76%;
                max-width: 320px;
                z-index: 2000;
                padding: 50px 0 24px;
                background-color: #ffffff;
                box-shadow: 2px 0 16px rgba(0, 0, 0, 0.2);
                overflow-y: auto;
                -webkit-overflow-scrolling: touch;
            }

            // 半透明遮罩：点击遮罩区域收起抽屉
            &::after {
                content: '';
                position: fixed;
                left: 0;
                top: 0;
                right: 0;
                bottom: 0;
                background-color: rgba(0, 0, 0, 0.45);
                z-index: 1999;
            }
        }

        // 主体：只显示当前路由对应的内容
        >div.right {
            width: 100%;
            // 必须 border-box：默认 content-box 会把 padding 加在 100% 宽度之外，撑出屏幕
            box-sizing: border-box;
            margin-left: 0;
            padding: 12px;
            // 内容超出时横向滑动查看，表单保持原有排版不被挤压
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
        }
    }
}
</style>
